<template>
    <vs-popup class="checkin-popup" title="Checkin Form" :active.sync="popupCheckin.isOpen" fullscreen>
      <vs-row class="mt-5">
        <vs-col vs-w="6" class="pr-6">
          <label class="label">Customer Name</label>
          <vs-input placeholder="Customer Name" v-model="name" class="w-full"/>
        </vs-col>
        <vs-col vs-w="6" class="pl-6">
          <label class="label">Customer Email</label>
          <vs-input placeholder="Customer Email" v-model="email" class="w-full"/>
        </vs-col>
      </vs-row>
      <div class="w-full px-4" style="position: absolute; bottom: 0; left: 0;">
        <vs-divider></vs-divider>
        <vs-row class="flex justify-center align-center pb-5">
          <vs-button type="border" @click="checkinSubmit">Submit</vs-button>
          <vs-button type="border" class="ml-4" color="danger" @click.stop="popupCheckin.isOpen=false">Cancel</vs-button>
        </vs-row>
      </div>
    </vs-popup>
</template>

<script>
export default {
  name: 'vs-popup-checkin',
  props: {
    popupCheckin:{
      type: Object,
      required: true,
    }
  },
  data(){
    return{
      name: '',
      email: '',
    }
  },
  methods:{
    checkinSubmit(){
      const obj = {
        full_name: this.name,
        email: this.email,
        phone: this.popupCheckin.item_info.phone
      }
      this.$store.dispatch("checkin/CHECKIN_SUBMIT", obj).then(() => {
        this.popupCheckin.isOpen = false;
        this.$vs.notify({
          title:'Success',
          text:'Check Phone Submit Success',
          color:'success',
          position:'top-right'
        })
      }).catch(() => {
        this.$vs.notify({
          title:'Fail',
          text:'Check Phone Submit Failed',
          color:'danger',
          position:'top-right'
        })
      })
    }
  }
}
</script>

<style lang="scss">
  .checkin-popup {
    .vs-popup--content {
      height: calc(100% - 36px);
      width: 100%;
      max-height: unset;
      margin: 0;
      padding-left: 2rem !important;
      padding-right: 2rem !important;
      position: relative;
      .vs-input--placeholder.normal {
        padding: 0.8rem;
      }
      .vs-input--icon {
        top: 11px;
      }
      .vs-input--input.hasIcon {
        padding: 0.55rem 1rem 0.55rem 3rem;
      }
      textarea {
        &::placeholder {
          opacity: 0.5;
          font-size: 12px;
        }
      }
    }
    .text{
      text-transform: none;
      font-family: Poppins, sans-serif;
      font-size: 12px;
      font-weight: normal;
      color: rgba(103, 118, 140, 0.5);
      margin-left: 5px;
    }
    .label{
      display: block;
      font-family: Poppins;
      font-size: 13px;
      text-transform: uppercase;
      font-weight: bold;
      margin-bottom: 5px;
    }
  }
</style>
